import React from "react";
import { Link } from "react-router-dom";
import { AppBar, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as KpmgLogo } from "../../Assets/kpmg-logo-dark.svg";
import { FlexBox } from "../Display/Flexbox";
import { AppBarStyles } from "./AppBarStyles";

export const Appbar: React.FC = () => {
  const styles = AppBarStyles();
  const { t } = useTranslation("attendanceFormlayout");
  return (
    <AppBar position="fixed" className={styles.appBar}>
      <Toolbar>
        <Link to="/trainerdetails" key="trainerdetails" aria-label="KPMG logo dark">
          <KpmgLogo />
        </Link>
        <Typography className={styles.title}>
          {t("header")}
        </Typography>
        <FlexBox />
      </Toolbar>
    </AppBar>
  );
};
